<template>
    <div class="reservation-header">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-8">
                    <div class="reservation-header-wrap">
                        <h1>Rezervácia zájazdu</h1>

                        <p class="text-right" v-if="reservationTimeState.timeUntilReservationEnds !== null">
                            Čas na dokončenie: <strong><ReservationCountdown v-model="showExpirationInfo" /></strong>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import ReservationCountdown from './ReservationCountdown.vue';
import { useReservationTime } from '../modules/useReservationTime';

const { reservationTimeState } = useReservationTime();
const showExpirationInfo = ref(false);

watch(showExpirationInfo, () => {
    reservationTimeState.timeUntilReservationEnds = 0;
});
</script>
